import { observer } from 'mobx-react';
import { Box } from '@material-ui/core';
import { lighten, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  container: {
    border: '2px solid rgba(133, 45, 202, 0.4)',
    borderRadius: '99px',
    backgroundColor: 'white',
    height: 80,
    paddingLeft: 50,
    paddingRight: 50,
    paddingTop: 24,
    paddingBottom: 24,
    display: 'flex',
    alignItems: 'center',
  },
  text: {
    marginLeft: '20px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    lineHeight: '20px',
    fontSize: 16,
  },
  icon: {
    color: '#666',
  },
}));

export const CapitalProviderInfo = observer(({ capitalProvider }) => {
  const classes = useStyles();
  return (
    <Box
      display="flex"
      alignItems={'center'}
      py={1}
      px={2}
      className={classes.container}
    >
      <CapitalProviderIcon className={classes.icon} />
      <Box className={classes.text}>
        <Box>Loan Funding:</Box>
        <Box>
          <b>External</b> {capitalProvider ? capitalProvider : 'Capital'}
        </Box>
      </Box>
    </Box>
  );
});

const CapitalProviderIcon = ({ className }) => {
  return (
    <svg className={className} width="30" height="31" viewBox="0 0 30 31">
      <path d="M6.66667 12H4V21.3333H6.66667V12Z" fill="currentColor" />
      <path d="M14.6667 12H12V21.3333H14.6667V12Z" fill="currentColor" />
      <path
        d="M26.6667 6.66667L13.3333 0L0 6.66667V9.33333H26.6667V6.66667Z"
        fill="currentColor"
      />
      <path
        d="M0 24V26.6667H16.5333C16.2533 25.8133 16.1067 24.92 16.0533 24H0Z"
        fill="currentColor"
      />
      <path
        d="M22.6667 15.0133V12H20V16.3467L22.6667 15.0133Z"
        fill="currentColor"
      />
      <path
        d="M24 17.3333L18.6667 20V23.4C18.6667 26.76 20.9467 29.9067 24 30.6667C27.0533 29.9067 29.3333 26.76 29.3333 23.4V20L24 17.3333ZM23.04 26.6667L20.3333 23.96L21.7467 22.5467L23.04 23.84L26.2533 20.6667L27.6667 22.08L23.04 26.6667Z"
        fill="currentColor"
      />
    </svg>
  );
};
